import PrescriptionContactForm from '@components/my-prescriptions/prescription-contact/PrescriptionContactForm';
import { IContactLensDetails, IMySavedPrescriptionItem } from '@interfaces/myAppointmentInterfaces';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers';

type Step2ContactProps = {
    isEditingPrescription: boolean;
    checkedDifferentCL?: boolean;
    selectedRightCL?: any;
    selectedLeftCL?: any;
    editedPrescription?: IMySavedPrescriptionItem;
    editedRightCLDetails?: IContactLensDetails;
    editedLeftCLDetails?: IContactLensDetails;
    backToStepTwoFirstName?: any;
    setBackToStepTwoFirstName?: any;
    backToStepTwoLastName?: any;
    setBackToStepTwoLastName?: any;
    backToStepTwoDob?: any;
    setBackToStepTwoDob?: any;
    backToStepTwoDoctor?: any;
    setBackToStepTwoDoctor?: any;
    backToStepTwoPowerOD?: any;
    setBackToStepTwoPowerOD?: any;
    backToStepTwoPowerOS?: any;
    setBackToStepTwoPowerOS?: any;
    backToStepTwoBcOD?: any;
    setBackToStepTwoBcOD?: any;
    backToStepTwoBcOS?: any;
    setBackToStepTwoBcOS?: any;
    backToStepTwoDiaOD?: any;
    setBackToStepTwoDiaOD?: any;
    backToStepTwoDiaOS?: any;
    setBackToStepTwoDiaOS?: any;
    backToStepTwoCylOD?: any;
    setBackToStepTwoCylOD?: any;
    backToStepTwoCylOS?: any;
    setBackToStepTwoCylOS?: any;
    backToStepTwoColorOD?: any;
    setBackToStepTwoColorOD?: any;
    backToStepTwoColorOS?: any;
    setBackToStepTwoColorOS?: any;
    backToStepTwoAxisOD?: any;
    setBackToStepTwoAxisOD?: any;
    backToStepTwoAxisOS?: any;
    setBackToStepTwoAxisOS?: any;
    backToStepTwoAddOD?: any;
    setBackToStepTwoAddOD?: any;
    backToStepTwoAddOS?: any;
    setBackToStepTwoAddOS?: any;
    backToStepTwoDomOD?: any;
    setBackToStepTwoDomOD?: any;
    backToStepTwoDomOS?: any;
    setBackToStepTwoDomOS?: any;
    isDifferentCLLeftFromBack?: boolean;
    isDifferentCLRightFromBack?: boolean;
};

const Step2Contact = (props: Step2ContactProps): JSX.Element => {
    const config = useSelector((state: RootState) => state.common.config);

    useEffect(() => {
        window?.tealium_data2track.push({
            id: 'Impression',
            Page_Section2: 'LensPrescription:CL2',
        });
    }, []);

    return (
        <div className="step2-container">
            <PrescriptionContactForm
                isEditingPrescription={props.isEditingPrescription}
                checkedDifferentCL={props?.checkedDifferentCL}
                selectedRightCL={props?.selectedRightCL}
                selectedLeftCL={props?.selectedLeftCL}
                editedPrescription={props?.editedPrescription}
                editedRightCLDetails={props?.editedRightCLDetails}
                editedLeftCLDetails={props?.editedLeftCLDetails}
                backToStepTwoFirstName={props?.backToStepTwoFirstName}
                setBackToStepTwoFirstName={props?.setBackToStepTwoFirstName}
                backToStepTwoLastName={props?.backToStepTwoLastName}
                setBackToStepTwoLastName={props?.setBackToStepTwoLastName}
                backToStepTwoDob={props?.backToStepTwoDob}
                setBackToStepTwoDob={props?.setBackToStepTwoDob}
                backToStepTwoDoctor={props?.backToStepTwoDoctor}
                setBackToStepTwoDoctor={props?.setBackToStepTwoDoctor}
                backToStepTwoPowerOD={props?.backToStepTwoPowerOD}
                setBackToStepTwoPowerOD={props?.setBackToStepTwoPowerOD}
                backToStepTwoPowerOS={props?.backToStepTwoPowerOS}
                setBackToStepTwoPowerOS={props?.setBackToStepTwoPowerOS}
                backToStepTwoBcOD={props?.backToStepTwoBcOD}
                setBackToStepTwoBcOD={props?.setBackToStepTwoBcOD}
                backToStepTwoBcOS={props?.backToStepTwoBcOS}
                setBackToStepTwoBcOS={props?.setBackToStepTwoBcOS}
                backToStepTwoDiaOD={props?.backToStepTwoDiaOD}
                setBackToStepTwoDiaOD={props?.setBackToStepTwoDiaOD}
                backToStepTwoDiaOS={props?.backToStepTwoDiaOS}
                setBackToStepTwoDiaOS={props?.setBackToStepTwoDiaOS}
                backToStepTwoCylOD={props?.backToStepTwoCylOD}
                setBackToStepTwoCylOD={props?.setBackToStepTwoCylOD}
                backToStepTwoCylOS={props?.backToStepTwoCylOS}
                setBackToStepTwoCylOS={props?.setBackToStepTwoCylOS}
                backToStepTwoColorOD={props?.backToStepTwoColorOD}
                setBackToStepTwoColorOD={props?.setBackToStepTwoColorOD}
                backToStepTwoColorOS={props?.backToStepTwoColorOS}
                setBackToStepTwoColorOS={props?.setBackToStepTwoColorOS}
                backToStepTwoAxisOD={props?.backToStepTwoAxisOD}
                setBackToStepTwoAxisOD={props?.setBackToStepTwoAxisOD}
                backToStepTwoAxisOS={props?.backToStepTwoAxisOS}
                setBackToStepTwoAxisOS={props?.setBackToStepTwoAxisOS}
                backToStepTwoAddOD={props?.backToStepTwoAddOD}
                setBackToStepTwoAddOD={props?.setBackToStepTwoAddOD}
                backToStepTwoAddOS={props?.backToStepTwoAddOS}
                setBackToStepTwoAddOS={props?.setBackToStepTwoAddOS}
                backToStepTwoDomOD={props?.backToStepTwoDomOD}
                setBackToStepTwoDomOD={props?.setBackToStepTwoDomOD}
                backToStepTwoDomOS={props?.backToStepTwoDomOS}
                setBackToStepTwoDomOS={props?.setBackToStepTwoDomOS}
                isDifferentCLLeftFromBack={props?.isDifferentCLLeftFromBack}
                isDifferentCLRightFromBack={props?.isDifferentCLRightFromBack}
            />
        </div>
    );
};
export default Step2Contact;
